/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryNoteWithCertificationNumbersChecked } from '../../models/delivery-note-with-certification-numbers-checked';
import { KeyType } from '../../models/key-type';

export interface GetSingleDeliveryNoteMetaDataAddons$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
}

export function getSingleDeliveryNoteMetaDataAddons(http: HttpClient, rootUrl: string, params: GetSingleDeliveryNoteMetaDataAddons$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryNoteWithCertificationNumbersChecked>> {
  const rb = new RequestBuilder(rootUrl, getSingleDeliveryNoteMetaDataAddons.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryNoteWithCertificationNumbersChecked>;
    })
  );
}

getSingleDeliveryNoteMetaDataAddons.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}';
